export default "__VITE_ASSET__CpoTjl8J__"